export enum GtmLoginStatus {
    LoggedIn = "logged in",
    LoggedOut = "logged out",
}

export default GtmLoginStatus;
